<template>
  <div>
    <div>
      <v-row class="pa-2">
        <v-col cols="12" class="d-block">
          <h3>
            Pflichtdateien <span v-if="addTitle">| {{ addTitle }}</span>
          </h3>
          <v-divider />
        </v-col>
        <v-col v-for="(file, aKey) in requiredFiles" :key="'a'+aKey" cols="12" md="6" lg="4" xl="3" class="d-flex">
          <v-card v-if="!file.path" width="100%">
            <v-card-title primary-title>
              {{ file.title }}
            </v-card-title>
            <v-card-text>
              <dropzone v-model="uploads[file.id]" height="210px" :multiple="false" />
            </v-card-text>
            <v-card-actions v-if="!file.path">
              <v-spacer />
              <v-btn flat color="primary" @click="submit(file.id)">
                speichern
              </v-btn>
            </v-card-actions>
          </v-card>
          <v-card v-else class="image-card" :height="rowHeight" width="100%" @click.stop="downloadFile(file)">
            <v-card-title primary-title>
              {{ file.title }}
            </v-card-title>
            <v-card-text height="100%" class="d-flex justify-center image">
              <v-icon x-large color="primary">
                <!-- <v-img :src="fileResource.url" /> -->
                {{ getIcon(file) }}
              </v-icon>
            </v-card-text>
            <v-card-title class="image-title">
              {{ file.filename }}
            </v-card-title>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <v-dialog v-model="deleteFilePrompt" width="400px">
      <v-card>
        <v-card-title>
          Datei entfernen
        </v-card-title>
        <v-card-text>
          Wollen Sie die Datei <b>{{ fileToDelete.name }}</b> entfernen ?
        </v-card-text>
        <v-divider />
        <v-card-actions class="d-flex justify-end">
          <v-btn color="primary" text>
            Abbrechen
          </v-btn>
          <v-btn color="secondary" text @click="deleteFile">
            Entfernen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Dropzone from '@/Components/Dropzone'
export default {
   name: 'RequiredFileManager',
   components: {
      Dropzone
   },
   model: {
      prop: 'requiredFiles',
      event: 'update:requiredFiles'
   },
   props: {
      requiredFiles: {
         required: true,
         type: Array
      },
      rowHeight: {
         type: String,
         default: '300px'
      },
      addTitle: {
         required: false,
         type: String,
         default () {
            return null
         }
      },

   },
   data: function () {
      return {
         icons: [
            { type: 'pdf', icon: 'file-pdf-box' },
            // { type: 'jpg', icon: 'file-jpg-box' },
            // { type: 'png', icon: 'file-png-box' },
            { type: 'vnd.openxmlformats-officedocument.spreadsheetml.sheet', icon: 'microsoft-excel' },
            { type: 'xlsx', icon: 'microsoft-excel' },
            { type: 'csv', icon: 'file-delimited' },
            { type: 'vnd.ms-excel', icon: 'file-delimited' },
         ],
         deleteFilePrompt: false,
         fileToDelete: {},
         uploads: []
      }
   },
   methods: {
      showDeleteFile (fileResource) {
         this.fileToDelete = fileResource
         this.deleteFilePrompt = true
      },
      deleteFile () {
         this.$inertia.patch(this.route('files.delete'), { file: this.fileToDelete }).then(response => {
            this.getAvailableFiles()
            this.deleteFilePrompt = false
         })
      },
      downloadFile (id) {
         window.open(this.route('required_files.download', { required_file: id })).focus()
      },
      getIcon (file) {
         let icon = 'mdi-file'
         for (const key in this.icons) {
            if (file.path.includes(this.icons[key].type)) {
               icon = 'mdi-' + this.icons[key].icon
               break
            }
         }
         //  if (icon === 'mdi-file' && file.mimeType.includes('image')) {
         //     icon = 'mdi-file-image'
         //  }
         return icon
      },
      submit (id) {
         const formData = {
            file: this.uploads[id]
         }
         this.$inertia.post(this.route('required_files.upload', { required_file: id }), formData)
      }
   }
}
</script>

<style scoped>
    .image-title{
        z-index: 1;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        border-top: 3px solid rgba(255, 255, 255, 0.55);
        background-color: rgba(0, 0, 0, 0.55);
        color: rgba(255, 255, 255, 0.55);
    }
    .image-card:hover .image-title{
        border-top: 3px solid rgba(255, 255, 255, 0.70);
        background-color: rgba(0, 0, 0, 0.70);
        color: rgba(255, 255, 255, 0.70);
    }
    .image{
        margin-top: 40%;
    }
    .close-icon{
        position: absolute;
        top: 10px;
        right: 10px;
        z-index: 1;
    }

</style>
